import { requestApi } from "../funcitons";

export const HeaderItemsQueries = {
    createItem: async (header_cell_id, item) => {
        const response = await requestApi('cells/header-items', 'POST', { header_cell_id, ...item });
        return response.data;
    },
    getItemById: async (id) => {
        const response = await requestApi(`cells/header-items/${id}`, 'GET');
        return response.data;
    },
    updateItem: async (id, item) => {
        const response = await requestApi(`cells/header-items/${id}`, 'PUT', item);
        return response.data;
    },
    deleteItem: async (id) => {
        const response = await requestApi(`cells/header-items/${id}`, 'DELETE');
        return response.data;
    },
}